import { useQuery } from "@tanstack/react-query";
import api from "../../services/api";
import { parsePaginatedResponse } from "../../utils/parsePaginatedResponse";

const ENQUIRY_KEYS = ["enquiries"];

export const useViewEnquiryList = ({ page, limit, q, scopeKey } = {}) => {
  const isPaginated = page !== undefined && limit !== undefined;
  const trimmedQ = q?.trim?.() ?? "";

  return useQuery({
    queryKey: isPaginated
      ? ["enquiryList", scopeKey, page, limit, trimmedQ]
      : ["enquiryList", scopeKey],
    queryFn: async () => {
      const params = {};
      if (isPaginated) {
        params.page = page;
        params.limit = limit;
        if (trimmedQ) params.q = trimmedQ;
      }

      const res = await api.get("/enquiry/list", { params });

      if (isPaginated) {
        const parsed = parsePaginatedResponse(res.data, ENQUIRY_KEYS, limit);
        return {
          enquiries: parsed.items,
          pagination: parsed.pagination,
        };
      }

      return res.data;
    },
    placeholderData: isPaginated
      ? (previousData, previousQuery) =>
          previousQuery?.queryKey?.[1] === scopeKey
            ? previousData
            : undefined
      : undefined,
    staleTime: isPaginated ? 60_000 : undefined,
    throwOnError: false,
    retry: false,
  });
};
